import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.healthCheckAnswers.loading;
export const selectErrorMessage = (state: RootState) =>
  state.healthCheckAnswers.error;
export const healthCheckAnswersResponse = (state: RootState) =>
  state.healthCheckAnswers.healthCheckAnswersResponse;
